import React, { useState } from "react";
import theme from "../../../../Styles/theme";
import Modal from "react-modal";
import {
  Container,
  PlusBenfeitoria,
  Table,
  TableContainer,
  Td,
  Th,
  Title,
  Tr,
} from "./styles";
import { IBenfeitoria } from "../../../../Pages/Cartorio_Pages/App_Pages/ImovelFocus";
import { Header } from "../../../Header";
import { Panel } from "../../../Panel";
import { FaWarehouse } from "react-icons/fa";
import { Plus } from "react-feather";
import { ModalDivX } from "../../../ModalDivX";
import { FormBenfeitoriaModal } from "./FormBenfeitoriaModal";
import { DefineOperationModal } from "./DefineOperationModal";
import api from "../../../../Services/api";
import { ModalLoader } from "../../../ModalLoader";
import { Alert } from "../../../Error/Alert";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: theme.colors.secondary,
    width: "80%",
    height: "70vh",

    borderRadius: "0.25rem",
  },
};

interface Props {
  open: boolean;
  onClose(): void;
  benfeitorias: IBenfeitoria[];
  handleSetBenfeitorias(ben: IBenfeitoria[]): void;
}

export function ModalBenfeitorias({
  open,
  onClose,
  benfeitorias,
  handleSetBenfeitorias,
}: Props) {
  const [benfeitoriaFocus, setBenfeitoriaFocus] = useState({} as IBenfeitoria);
  const [openModal, setOpenModal] = useState(false);
  const [openModalChoseAction, setOpenModalChoseAction] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState({ message: "", title: "" });

  function handleAddBenfeitoria(benf: IBenfeitoria) {
    if (benfeitoriaFocus.ID) {
      const posicao = benfeitorias.indexOf(benfeitoriaFocus);
      benfeitorias[posicao] = benf;
    } else {
      if (benfeitorias.length > 0) {
        benfeitorias.unshift(benf);
      } else {
        handleSetBenfeitorias([benf]);
        return;
      }
    }

    handleSetBenfeitorias(benfeitorias);
  }

  function renderBenfeitorias() {
    if (benfeitorias) {
      if (benfeitorias.length > 0) {
        return benfeitorias.map((item) => {
          let tipo = item.AREA_TIPO.trim() === "M" ? "m²" : "%";
          return (
            <Tr
              onClick={() => {
                setBenfeitoriaFocus(item);
                setOpenModalChoseAction(true);
              }}
            >
              <Td>{item.ID}</Td>
              <Td>{item.TIPO}</Td>
              <Td>{item.DESCRICAO}</Td>
              <Td>{item.MATERIAL}</Td>
              <Td>
                {(
                  item.AREA.toLocaleString("pt-br", {
                    style: "currency",
                    currency: "BRL",
                    minimumFractionDigits: 6,
                  }) + tipo
                )
                  .toLocaleLowerCase()
                  .replaceAll("r$", "")}
              </Td>
              <Td>
                {(
                  (item.AREA_TRANSMITIDA !== null && item.AREA_TRANSMITIDA !== undefined
                    ? item.AREA_TRANSMITIDA.toLocaleString("pt-BR", {
                      minimumFractionDigits: 6,
                      maximumFractionDigits: 6,
                    })
                    : item.AREA.toLocaleString("pt-BR", {
                      minimumFractionDigits: 6,
                      maximumFractionDigits: 6,
                    })) + tipo
                ).toLowerCase()}
              </Td>

              <Td>{item.ANO}</Td>
            </Tr>
          );
        });
      }
    }
  }

  return (
    <Modal isOpen={open} onRequestClose={onClose} style={customStyles}>
      <ModalDivX execute={onClose} />
      <Container>
        <Title>
          <FaWarehouse
            size={"max(18px, 1.5vw)"}
            style={{ marginRight: "1vw" }}
          />{" "}
          BENFEITORIAS
        </Title>
        <TableContainer>
          <Table>
            <Tr>
              <Th>CÓDIGO</Th>
              <Th>TIPO</Th>

              <Th>DESCRIÇÃO</Th>
              <Th>MATERIAL</Th>
              <Th>ÁREA TOTAL</Th>
              <Th>ÁREA TRANSMITIDA</Th>
              <Th>ANO</Th>
            </Tr>
            {renderBenfeitorias()}
          </Table>
        </TableContainer>
        <PlusBenfeitoria
          onClick={() => {
            setBenfeitoriaFocus({} as IBenfeitoria);
            setOpenModal(true);
          }}
        >
          <FaWarehouse size={"max(18px, 1.5vw)"} />
          <Plus size={"max(15px, 1.2vw)"} />
        </PlusBenfeitoria>
      </Container>

      <FormBenfeitoriaModal
        benfeitoria={benfeitoriaFocus}
        onClose={() => setOpenModal(false)}
        handleSetBenfeitoria={handleAddBenfeitoria}
        open={openModal}
      />
      <DefineOperationModal
        open={openModalChoseAction}
        onClose={() => {
          setOpenModalChoseAction(false);
        }}
        confirmOperation={() => {
          setOpenModalChoseAction(false);
          setOpenModal(true);
        }}
        cencelOperation={() => {
          const teste = async () => {
            try {
              const { data } = await api.delete(
                `/benfeitorias/${benfeitoriaFocus.ID}`
              );

              const posicao = benfeitorias.indexOf(benfeitoriaFocus);

              benfeitorias.splice(posicao, 1);
              if (benfeitorias && benfeitorias.length > 0) {
                handleSetBenfeitorias(benfeitorias);
              } else {
                handleSetBenfeitorias({} as IBenfeitoria[]);
              }
              setOpenModalChoseAction(false);
            } catch (error) {
              setError({
                message: "Não foi possível excluir a Benfeitoria!",
                title: "Ops!",
              });
            } finally {
              setLoading(false);
            }
          };

          teste();
        }}
      />
      <ModalLoader loading={loading} />
      <Alert
        open={error.message.length > 0}
        onClose={() => setError({ message: "", title: "" })}
        message={error.message}
        title={error.title}
      />
    </Modal>
  );
}
